import React, { Component } from "react"
import logo from "../../images/logo/Black.png"
import { Link } from "gatsby"
import "../../style/navbar.scss"
import NavDropdown from "react-bootstrap/NavDropdown"

import celerIMSDKPng from "../../images/logo/celerIMSDK.png"
import cBridgeSDKPng from "../../images/logo/cBridgeSDK.png"
import stateGuardianNetworkPng from "../../images/logo/stateGuardianNetwork.png"
import celerCBridgePng from "../../images/logo/celerCBridge.png"
import layer2FinancePng from "../../images/logo/layer2Finance.png"

if (typeof window !== "undefined") {
  // Make scroll behavior of internal links smooth
  // eslint-disable-next-line global-require
  require("smooth-scroll")('a[href*="#"]')
}

export default class NavBar extends Component {
  state = {
    navbarOpen: false,
    navToggle: "nav-bg",
    navLinkToggle: "links links-collapse",
    menuToggle: "",
  }

  navbarHandler = () => {
    this.state.navbarOpen
      ? this.setState({
          navbarOpen: false,
          navToggle: "nav-bg",
          navLinkToggle: "links links-collapse",
          menuToggle: "",
        })
      : this.setState({
          navbarOpen: true,
          navToggle: "nav-bg-active",
          navLinkToggle: "links links-collapse-active",
          menuToggle: "change",
        })
  }

  render() {
    return (
      <div className="nav-menu">
        <div className="container-fluid">
          <nav className="nav-container">
            <div className="brand">
              <Link to="/">
                <img
                  src={logo}
                  height="44px"
                  className="my-lg-3 my-md-3"
                  alt=""
                />
              </Link>
            </div>

            <div className="toggler">
              <button onClick={this.navbarHandler}>
                <span className={this.state.menuToggle}>
                  <div className="bar1"></div>
                  <div className="bar2"></div>
                  <div className="bar3"></div>
                </span>
              </button>
            </div>

            <div className={this.state.navLinkToggle}>
              <ul className="link-container align-items-center">
                <li>
                  <Link to="/">home</Link>
                </li>
                <li>
                  <NavDropdown title="Product" id="collasible-nav-dropdown">
                    <NavDropdown.Item href="https://sgn.celer.network/">
                      <img
                        src={stateGuardianNetworkPng}
                        className="p-3"
                        alt=""
                      />
                      State Guardian Network
                    </NavDropdown.Item>
                    <NavDropdown.Item href="https://zk.layer2.finance/">
                      <img src={layer2FinancePng} className="p-3" alt="" />
                      layer2.finance
                    </NavDropdown.Item>
                    <NavDropdown.Item href="https://cbridge.celer.network/">
                      <img src={celerCBridgePng} className="p-3" alt="" />
                      cBridge
                    </NavDropdown.Item>
                  </NavDropdown>
                </li>
                <li>
                  <Link to="/technology">technology</Link>
                </li>
                <li>
                  <NavDropdown title="build" id="collasible-nav-dropdown">
                    <NavDropdown.Item href="https://cbridge-docs.celer.network/developer/cbridge-sdk">
                      <img src={cBridgeSDKPng} className="p-3" alt="" />
                      cBridge SDK
                    </NavDropdown.Item>
                    <NavDropdown.Item href="https://im-docs.celer.network/developer/celer-im-overview">
                      <img src={celerIMSDKPng} className="p-3" alt="" />
                      Celer IM SDK
                    </NavDropdown.Item>
                  </NavDropdown>
                </li>
                <li>
                  <a
                    href="https://blog.celer.network/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    blog
                  </a>
                </li>
                <li>
                  <Link to="/community">community</Link>
                </li>
                <li>
                  <Link to="/about">about</Link>
                </li>
                <li>
                  <Link to="/career">career</Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
        <div className={this.state.navToggle} />
      </div>
    )
  }
}
